import {
  GET_LOOKUP_PROVINCE_OK,
  GET_LOOKUP_PROVINCE_ERR,
} from "./lookup-province.action";

const InitState = {
  error: null,
  content: null,
};

export default function LookupProvinceReducer(state = InitState, action) {
  switch (action.type) {
    case GET_LOOKUP_PROVINCE_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case GET_LOOKUP_PROVINCE_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    default:
      return state;
  }
}
